/* eslint-disable */
import moment from 'moment';
/* eslint-disable no-extend-native */
import PropTypes from 'prop-types';
import tableToCsv from 'node-table-to-csv';
import React from 'react';
import { Link } from 'react-router-dom';
import {Button, Col, Row} from 'react-bootstrap';
import PrintProvider, { NoPrint, Print } from 'react-easy-print';
import { renderToString } from 'react-dom/server'
import { connect } from 'react-redux';
import { Field, Form, reduxForm } from 'redux-form';
import { load as loadEmployees } from '../../reducers/employees/employees.actions';
import { notAdmins } from '../../reducers/employees/employees.reducer';
import { load } from '../../reducers/employeeStats/employeeStats.actions';
import { loading, stats } from '../../reducers/employeeStats/employeeStats.reducer';
import { load as loadSubContractors } from '../../reducers/subContractor/subContractor.actions';
import { load as loadSubContractorStats } from '../../reducers/subContractorStats/subContractorStats.actions';
import { stats as subContractorStats } from '../../reducers/subContractorStats/subContractorStats.reducer';
import DateFormGroup from '../Forms/DateFormGroup/DateFormGroup';
import { Spinner } from '../Spinner/Spinner';
import SpinnerButton from '../SpinnerButton/SpinnerButton';
import './EmployeeStats.css';
import {subContractors} from "../../reducers/subContractor/subContractor.reducer";


// eslint-disable-next-line object-curly-newline
export class EmployeeStats extends React.Component {
  constructor() {
    super();
    this.state = {
      start: undefined,
      end: undefined,
    };
  }

  componentDidMount() {
    this.props.loadEmployees();
    this.props.loadSubContractors();
  }

  setDates(start, end) {
    this.setState({
      start,
      end,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  getDates(startDate, stopDate) {
    const dateArray = [];
    let currentDate = moment(startDate);
    while (currentDate <= moment(stopDate)) {
      dateArray.push(currentDate.format('M/D'));
      currentDate = currentDate.add(1, 'days');
    }
    return dateArray;
  }

  getAllDates() {
    return this.getDates(this.state.start, this.state.end);
  }

  getDateRows() {
    return this.getAllDates().map(date => (
      <td className="center" >{date}</td>));
  }

  getEmployeeObject() {
    return this.props.employees.reduce((object, v) => {
      object[v.name] = { '': {} };
      return object;
    }, {});
  }

  getSubContractorObject() {
    return this.props.subContractors.reduce((object, v) => {
      object[v.name] = { '': {} };
      return object;
    }, {});
  }

  getCsv(allStats) {
    const rows = [];
    const statsAndEmployees = { ...this.getEmployeeObject(), ...allStats };
    rows.push(`Name, Project, ${this.getAllDates().map(date => date)}, Total\n`);


    Object.keys(statsAndEmployees).forEach((employeeName) => {
      const projects = statsAndEmployees[employeeName];
      const projectNames = Object.keys(projects);

      projectNames.forEach((projectName) => {
        rows.push(`${employeeName},${projectName},${this.getAllDates().map((date) => `${projects[projectName][date] ? projects[projectName][date].hours : ''},`)},${Object.values(projects[projectName]).reduce((total, hour) => total + Number.parseInt(hour.hours, 10), 0)}\n`);
      });
    });

    const element = document.createElement("a");
    const file = new Blob(rows, {type: 'text/plain'});
    element.href = URL.createObjectURL(file);
    element.download = "EmployeeStats.csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  };

  getHourLink(projects, projectName, date) {
    if(projects[projectName][date]['workorders'].length > 0) {
      return projects[projectName][date]['workorders'].map((id) =>
        <Link to={`/admin/workorders/${id}`}> {projects[projectName][date].hours} </Link>
      );
    } else {
      return (<Link to={`/admin/workorders/${projects[projectName][date]['workorder_id']}`}>
        {projects[projectName][date].hours}
      </Link>);
    }
  }

  getSubContractorRows(allStats) {
    const rows = [];
    const statsAndSubContractors = { ...this.getSubContractorObject(), ...allStats };
    Object.keys(statsAndSubContractors).forEach((subContractorName) => {
      const projects = statsAndSubContractors[subContractorName];
      const subContractorHours = Object.values(projects).map(v => (v ? Object.values(v) : []));
      const subContractorTotal = [].concat(...subContractorHours).reduce((total, hour) => total + Number.parseInt(hour.hours, 10), 0);
      const projectNames = Object.keys(projects);
      const projectCount = projectNames.length;

      rows.push((
        <tr className="subContractor_top" />
      ));

      projectNames.forEach((projectName, index) => {
        const topRowClass = index === 0 ? 'subContractor_top' : '';
        const alternateRowClass = index % 2 ? 'stat_row_dark' : '';

        rows.push((
          <tr className={topRowClass + alternateRowClass} >
            {index === 0 && <td rowSpan={projectCount + 1} >{subContractorName}</td>}
            <td>{projectName}</td>
            {
              this.getAllDates().map((date) => {
                const isMoreThanTenHoursToday = projectNames.reduce((total, name) => {
                  if (projects[name] && projects[name][date]) total = total + projects[name][date].hours;
                  return total;
                }, 0) > 10;
                const highlightClass = isMoreThanTenHoursToday ? 'highlight-row' : '';

                return (
                  <td className={`center ${highlightClass}`} >
                    {projects[projectName][date] && this.getHourLink(projects, projectName, date) }
                  </td>
                )
              })
            }
            <td className="center" >
              {Object.values(projects[projectName]).reduce((total, hour) => total + Number.parseInt(hour.hours, 10), 0)}
            </td>
            {index === 0 && <td className="center" rowSpan={projectCount + 1} >{subContractorTotal}</td>}
          </tr>
        ));
      });
    });
    return rows;
  }

  getRows(allStats) {
    const rows = [];
    const statsAndEmployees = { ...this.getEmployeeObject(), ...allStats };
    Object.keys(statsAndEmployees).forEach((employeeName) => {
      const projects = statsAndEmployees[employeeName];
      const employeeHours = Object.values(projects).map(v => (v ? Object.values(v) : []));
      const employeeTotal = [].concat(...employeeHours).reduce((total, hour) => total + Number.parseInt(hour.hours, 10), 0);
      const projectNames = Object.keys(projects);
      const projectCount = projectNames.length;

      rows.push((
        <tr className="employee_top" />
      ));

      projectNames.forEach((projectName, index) => {
        const topRowClass = index === 0 ? 'employee_top' : '';
        const alternateRowClass = index % 2 ? 'stat_row_dark' : '';

        rows.push((
          <tr className={topRowClass + alternateRowClass} >
            {index === 0 && <td rowSpan={projectCount + 1} >{employeeName}</td>}
            <td>{projectName}</td>
            {
              this.getAllDates().map((date) => {
                const isMoreThanTenHoursToday = projectNames.reduce((total, name) => {
                  if (projects[name] && projects[name][date]) total = total + projects[name][date].hours;
                  return total;
                }, 0) > 10;
                const highlightClass = isMoreThanTenHoursToday ? 'highlight-row' : '';

                return (
                  <td className={`center ${highlightClass}`} >
                    {projects[projectName][date] && this.getHourLink(projects, projectName, date) }
                  </td>
                )
              })
            }
            <td className="center" >
              {Object.values(projects[projectName]).reduce((total, hour) => total + Number.parseInt(hour.hours, 10), 0)}
            </td>
            {index === 0 && <td className="center" rowSpan={projectCount + 1} >{employeeTotal}</td>}
          </tr>
        ));
      });
    });
    return rows;
  }

  render() {

    return (
      <span>
        <PrintProvider>
          <NoPrint force>
            {this.props.loading && <Spinner isLoading /> }
            <Form onSubmit={() => {}} >
              <Row>
                <Col xs={12} sm={5} >
                  <Field
                    component={DateFormGroup}
                    name="start_date"
                    label="Start Date"
                    required
                  />
                </Col>
                <Col xs={12} sm={5} >
                  <Field
                    component={DateFormGroup}
                    name="end_date"
                    label="End Date"
                    required
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={2} >
                  <SpinnerButton onClick={this.props.handleSubmit((v) => {
                    this.props.load(v.start_date, v.end_date);
                    this.props.loadSubContractorStats(v.start_date, v.end_date);
                    this.setDates(v.start_date, v.end_date);
                  })}
                  >
                    Show
                  </SpinnerButton>
                </Col>
              </Row>
            </Form>
            { this.state.start && this.state.end && <Button onClick={() => this.getCsv(this.props.stats)}>CSV</Button>}
          </NoPrint>
          <Print>
            <table className="employee_stats" >
              <thead>
                <tr>
                  <td>
                    Name
                  </td>
                  <td>
                    Project
                  </td>
                  {this.getDateRows()}
                  <td className="center" >
                    Total
                  </td>
                  <td>
                    Emp. Total
                  </td>
                </tr>
              </thead>
              { this.getRows(this.props.stats) }
            </table>
            <br />
            <br />
            <table className="employee_stats" >
              <thead>
                <tr>
                  <td>
                    Name
                  </td>
                  <td>
                    Project
                  </td>
                  {this.getDateRows()}
                  <td className="center" >
                    Total
                  </td>
                  <td>
                    Emp. Total
                  </td>
                </tr>
              </thead>
              { this.getSubContractorRows(this.props.subContractorStats) }
            </table>
          </Print>
        </PrintProvider>
      </span>
    );
  }
}

EmployeeStats.propTypes = {
  load: PropTypes.func.isRequired,
  loadSubContractorStats: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loadEmployees: PropTypes.func.isRequired,
  loadSubContractors: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  stats: PropTypes.arrayOf({}).isRequired,
  subContractorStats: PropTypes.arrayOf({}).isRequired,
  employees: PropTypes.arrayOf({}).isRequired,
  subContractors: PropTypes.arrayOf({}).isRequired,
};

export const mapStateToProps = state => ({
  loading: loading(state),
  employees: notAdmins(state),
  stats: stats(state),
  subContractors: subContractors(state),
  subContractorStats: subContractorStats(state),
  form: 'stats',
});

export const mapDispatchToProps = dispatch => ({
  load: (start, end) => dispatch(load(start, end)),
  loadEmployees: () => dispatch(loadEmployees()),
  loadSubContractorStats: (start, end) => dispatch(loadSubContractorStats(start, end)),
  loadSubContractors: () => dispatch(loadSubContractors()),
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm()(EmployeeStats));



// WEBPACK FOOTER //
// ./src/components/EmployeeStats/EmployeeStats.jsx